import { Header } from '../../components/header'
import { Footer } from '../../components/footer'
import { AboutUs } from '../../components/aboutUs'
import { Banner } from '../../components/bannerHome'
import { QuickAccess } from '../../components/quickAccess'
import { OurHospitals } from '../../components/ourHospitals'
import Cinza from '../../assets/images/grey.png'
import Casa from '../../assets/images/house.png'
import Doente from '../../assets/images/sickPerson.jpg'
import Princeton from '../../assets/images/princeton.jpg'
import seattleGrace from '../../assets/images/seatle-grace.jpg'
import bannerImage from '../../assets/images/doctorNpatient.jpg'
import './style.css'

export function Home() {
  const hospitals = [
    {
      title: 'Princeton-Plainsboro',
      description: 'Atendimento 24h',
      image: Princeton,
      route: 'https://house.fandom.com/wiki/Princeton-Plainsboro_Teaching_Hospital'
    },
    {
      title: 'Seattle Grace',
      description: 'Especialidades médicas',
      image: seattleGrace,
      route: 'https://greysanatomy.fandom.com/wiki/Seattle_Grace_Hospital'
    }
  ]

  const cards = [
    {
      title: 'Portal do Paciente',
      image: Doente,
      route: '/login-paciente'
    },
    {
      title: 'Portal do Médico',
      image:  Casa,
      route: '/login-funcionario'
    },
    {
      title: 'Portal do Administrador',
      image: Cinza,
      route: '/login-funcionario'
    }
  ]

  return (
    <div className="home-page">
      <Header />
      <main>
        <section>
          <Banner
            title="VidaPlus"
            subtitle="Sua solução completa para uma vida mais saudável"
            backgroundImage={`url(${bannerImage})`}
          />
        </section>
        <OurHospitals hospitals={hospitals} />
        <AboutUs
          image={bannerImage}
          title="VidaPlus Donec fermentum odio tristique facilisis dictum. Curabitur nec."
          description="Aenean luctus libero ac felis sollicitudin, sed vehicula diam tincidunt. Aliquam est eros, mollis in mattis at, elementum vel nisl. Ut feugiat est id neque lobortis, vitae finibus nibh lacinia. Integer ut augue vel metus egestas scelerisque id et felis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent semper tortor risus, quis ullamcorper diam vulputate vitae. Sed non rhoncus nulla, quis pulvinar urna. Praesent luctus rutrum sem sit amet consectetur."
          linkText="Saiba mais"
          route="/institucional"
        />
        <QuickAccess cards={cards} />
      </main>
      <Footer />
    </div>
  )
}
